<template lang="pug">
  .box.position-relative
    .lista-solicitud-vacaciones.contenedor-interno
      .title
        span Solicitudes de vacaciones no aprobadas
        span.icon.close(
          @click="$emit('close')"
        )
          i.fa.fa-close

      transition(name="fade")
        div.position-relative(
          v-if="!isEditing"
          key="list-solicitudes"
        )
          transition(
            name='fade',
            tag="div",
            v-if="mostrarConfirmacionEnviar"
            )
            confirmar-accion-overlay(
              @close="mostrarConfirmacionEnviar = false"
              @do="aprobar"
              ref="confirmarAprobar"
            )
              span(slot="title") ¿Desea Aprobar la solicitud?
              span(slot="primaryAction")
                template(v-if="isSending")
                  | Aprobando...
                template(v-else)
                  | Aprobar


          transition(
            name='fade',
            tag="div",
            v-if="mostrarConfirmacionRechazar"
            )
            confirmar-accion-overlay(
              @close="mostrarConfirmacionRechazar = false"
              @do="rechazar"
              ref="confirmarRechazar"
            )
              span(slot="title") ¿Desea rechazar la solicitud?
              span(slot="primaryAction")
                template(v-if="isSending")
                  | Rechazando...
                template(v-else)
                  | Rechazar
          transition(
            name='fade',
            tag="div",
            v-if="mostrarConfirmacionRechazarMasiva"
            )
            confirmar-accion-overlay(
              @close="mostrarConfirmacionRechazarMasiva = false"
              @do="rechazarMasivo"
              ref="confirmarRechazarMasiva"
            )
              span(slot="title") ¿Desea rechazar masivamente?
              span(slot="primaryAction")
                template(v-if="isSending")
                  | Rechazando...
                template(v-else)
                  | Rechazar
          transition(
            name='fade',
            tag="div",
            v-if="mostrarConfirmacionAprobarMasiva"
            )
            confirmar-accion-overlay(
              @close="mostrarConfirmacionAprobarMasiva = false"
              @do="aprobarMasivo"
              ref="confirmarAprobarMasiva"
            )
              span(slot="title") ¿Desea aprobar masivamente?
              span(slot="primaryAction")
                template(v-if="isSending")
                  | Aprobando...
                template(v-else)
                  | Aprobar
          .acciones.display-flex.aic.jcc.mb-10(v-if="isSeleccionMasiva")
            button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
              span.icon.is-small
                i.fa.fa-paper-plane-o
              span Aprobar
            button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
              span.icon.is-small
                i.fa.fa-times
              span Rechazar
          .body
            table.table.is-striped.is-bordered
              thead
                th
                  input(type="checkbox", name="solicitud", :checked="seleccionadosTodos", @change="check('all')")
                th Nombre
                th Fecha
                th.hide-break-1 Retorno
                th Estado
                th.hide-break-1(v-if="!isSeleccionMasiva") Acciones
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o,index) in solicitudes"
                  :key="index"
                )
                  td.ta-center
                    input(type="checkbox", :id="o.id", :checked="o.seleccionado", @change="check(o)")
                  td
                    span.hint--top(:aria-label="'Empleado: '+o.dniEmpleado") {{ o.nombreEmpleado }}
                  td
                    .td-wrapper
                      .dates-wrapper.hint--top(:aria-label="'Solicitud: ' + o.id")
                        span {{ o.desde }}
                        template(v-if="o.desde !== o.hasta")
                          span.hide-break-1 &nbsp;-&nbsp;
                          span {{ o.hasta }}

                      div.show-break-1.dates-wrapper
                        span.has-text-bold Retorno:
                        span {{ o.retorno }}
                        span.email ({{ o.dias }} días)
                        span.email.has-text-danger {{ o.diasPasados }} días pasados
                  td.hide-break-1
                    .td-wrapper
                      span {{ o.retorno }}&nbsp;
                      span.email ({{ o.dias }} días)
                      br
                      span.email.has-text-danger {{ o.diasPasados }} días pasados
                  td
                    .td-wrapper
                      strong {{ o.estadoData.descripcion }}
                      br
                      .show-break-1.contenedor-acciones(v-if="!isSeleccionMasiva")
                        button.button.is-small(@click="confirmarAprobar(o)")
                          span.icon.is-small
                            i.fa.fa-paper-plane-o
                          span Aprobar
                        button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                          span.icon.is-small
                              i.fa.fa-times
                          span Rechazar
                  td.hide-break-1(v-if="!isSeleccionMasiva")
                    .td-wrapper
                      .contenedor-acciones
                        button.button.is-small(@click="confirmarAprobar(o)")
                          span.icon.is-small
                            i.fa.fa-paper-plane-o
                          span Aprobar
                        button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                          span.icon.is-small
                              i.fa.fa-times
                          span Rechazar
            loading(v-if="isLoading")
          .acciones.display-flex.aic.jcc.mb-10(v-if="isSeleccionMasiva")
            button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
              span.icon.is-small
                i.fa.fa-paper-plane-o
              span Aprobar
            button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
              span.icon.is-small
                i.fa.fa-times
              span Rechazar
</template>

<script>
import { apiGet, apiPost, apiPut, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'

// import data from '../util/data'
export default {
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      isEditing: false,
      isLoading: true,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazarMasiva: false,
      isSending: false,
      screenWidth: window.innerWidth,
      seleccionadosTodos: false
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  computed: {
    isSeleccionMasiva () {
      return this.solicitudes.filter(o => o.seleccionado).length > 0
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  methods: {
    check (row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos
        for (let i = 0; i < this.solicitudes.length; i++) {
          this.$set(this.solicitudes[i], 'seleccionado', this.seleccionadosTodos);
        }
        return
      }
      row.seleccionado = !row.seleccionado
      if (!row.seleccionado) {
        this.seleccionadosTodos = false
      }
    },
    confirmarRechazoMasivo () {
      this.mostrarConfirmacionRechazarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarAprobarMasivo () {
      this.mostrarConfirmacionAprobarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/vacaciones/rrhh/noaprobadas', obj, function (data) {
        vm.solicitudes = data.lista
        if (vm.solicitudes.length === 0) vm.$emit('close')
      }, function (error) {
        alert('error: ' + error.message)
      },
      function () {
        vm.isLoading = false
      }
      )
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionEnviar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarAprobar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    aprobar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: vm.solicitudSeleccionada.id
      }

      apiPost(vm, '/vacaciones/rrhh/noaprobadas', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false
        vm.fetch()
        notify(vm, 'success', 'Solicitud aprobada', 'La solicitud ha sido aprobada')
      }, function (error) {
        alert('error:' + error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiPut(vm, '/vacaciones/empleado/solicitud/nolotomo', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazarMasivo () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        ids: vm.solicitudes.filter(o => o.seleccionado).map(o => o.id)
      }
      apiPut(vm, '/vacaciones/empleado/solicitud/nolotomo/masivo', obj, function (data) {
        vm.isLoading = false
        vm.mostrarConfirmacionRechazarMasiva = false
        notify(vm, 'success', 'Éxito', 'Solicitudes rechazadas')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    aprobarMasivo () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        ids: vm.solicitudes.filter(o => o.seleccionado).map(o => o.id)
      }
      apiPost(vm, '/vacaciones/rrhh/noaprobadas/masivo', obj, function (data) {
        vm.isLoading = false
        vm.mostrarConfirmacionAprobarMasiva = false
        vm.fetch()
        notify(vm, 'success', 'Éxito', 'Solicitudes aprobadas')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .ta-center
    text-align center
  .detalle
    display flex
    flex-wrap: wrap;
    justify-content center
  .has-text-danger
    color #ff3860 !important
  .contenedor-interno
    .close
      position absolute
      right 5px
      top 5px
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      padding-right: 10px
      padding-left: 10px
      span
        font-weight bold
        text-transform uppercase

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
      // i
      //   font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  th
    text-align center

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px

  .lista-solicitud-vacaciones
  td
    .email
      font-size 12px
      color #9a9a9a

  .show-break-1
    display none

  // .hide-break-1
  //   display initial



  @media (max-width 970px)
    td
      text-align: center
      vertical-align: middle
      .contenedor-acciones
        flex-direction: column
        .button
          margin-bottom 5px
          &:last-child
            margin-bottom 0px

  @media (max-width 970px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column


    .show-break-1
      display initial

    .hide-break-1
      display none
</style>



// WEBPACK FOOTER //
// Component_Solicitudes_No_Aprobadas.vue?91bba004